import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Cineminuto_Title } from '../../../../../utils/EN/Modals/SpotsModals';

const ModalCineminuto = () => {
  return (
    <>
      <ModalVideo
        id="spot-cineminuto"
        dataText={Cineminuto_Title}
        videoSrc="https://player.vimeo.com/video/395269889?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_CINEMINUTO"
      />
    </>
  );
};

export default ModalCineminuto;
